import { render, staticRenderFns } from "./OpenIndicator.vue?vue&type=template&id=7d80b3fa&scoped=true&lang=pug&"
import script from "./OpenIndicator.vue?vue&type=script&lang=js&"
export * from "./OpenIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d80b3fa",
  null
  
)

export default component.exports